import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import router from "@/router";
import Head from "@/components/head/Head.vue";
import PathError from "@/assets/images/404.png"
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {

const title = ref("错误页面");
function onBack() {
  router.push("/login");
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Head, {
      headHeight: 44,
      title: title.value
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_result, {
        title: "404",
        "sub-title": "抱歉，请求错误"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_el_image, { src: _unref(PathError) }, null, 8, ["src"])
        ]),
        extra: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onBack
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("返回")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})